/* Version: 3.5.149 */
'use client';
import 'react';
import PropTypes from 'prop-types';

// NOTE: Will be removed in v4
// https://github.com/manulife-innersource/mux-core/issues/2526
// eslint-disable-next-line no-unused-vars
var SideNavSection = function SideNavSection(_ref) {
  var children = _ref.children;
  return children;
};
SideNavSection.propTypes = {
  children: PropTypes.node.isRequired
};
process.env.NODE_ENV !== "production" ? SideNavSection.displayName = 'SideNavSection' : undefined;

export { SideNavSection as default };
